export default {
  // Header
  'header.features': '機能',
  'header.whyDifferent': 'なぜ違うのか',
  'header.faq': 'よくある質問',
  'header.joinEarlyAccess': '早期アクセスに参加',

  // Hero Section
  'hero.title.part1': 'あなたの AI フレンド',
  'hero.title.part2': '時間を失うことから救う',
  'hero.description': 'Scrollmate は、あなたの習慣、目標、そして',
  'hero.description.highlight': '無限スクロール',
  'hero.description.part2': 'に最も弱い瞬間を理解する AI フレンドです。次の1時間が消える前に、優しく立ち止まるのを助けてくれる思いやりのある友人のように現れます。',
  'hero.joinEarlyAccess': '早期アクセスに参加',
  'hero.learnMore': '詳しく見る',

  // Core Features
  'features.title': '3つのコア機能',
  'features.feature1.title': 'あなたの目標を知っている',
  'features.feature1.description': '目標を直接設定したり、カレンダーと同期したりできます。早く寝たい、深夜のスクロールを減らしたいなど、あなたのフレンドはその意図を覚えて優しくサポートします。',
  'features.feature2.title': 'その瞬間に介入できる',
  'features.feature2.description': 'ブロックしたり叱ったりする代わりに、Scrollmate はループにはまった時に現れ、罪悪感ではなく気づきを持って立ち止まるのを助けます。',
  'features.feature3.title': 'あなたの習慣を理解している',
  'features.feature3.description': 'Scrollmate は、特に夜間など、あなたがコントロールを失いがちな時を学習します。最も弱い時間帯に、タイムリーで思いやりのあるサポートを提供します。',

  // Why Different
  'whyDifferent.title': 'なぜ Scrollmate は違うのか',
  'whyDifferent.notBlocker.title': 'ブロッカーではない',
  'whyDifferent.notBlocker.description': 'ほとんどのブロッカーは、あなたのスクロールを人間のパターンではなく、規律の問題として扱います。',
  'whyDifferent.notReporter.title': 'スクリーンタイムレポーターではない',
  'whyDifferent.notReporter.description': 'スクリーンタイムレポーターは過去を見せるだけで、実際にサポートが必要な瞬間には決して助けてくれません。',
  'whyDifferent.whatItIs.title': 'Scrollmate が本当に何であるか',
  'whyDifferent.whatItIs.point1.title': 'あなたが望むものを知っている',
  'whyDifferent.whatItIs.point1.description': 'あなたの目標、意図、そして築こうとしているより健康的な習慣。',
  'whyDifferent.whatItIs.point2.title': 'あなたがいつ自制心を失うかを知っている',
  'whyDifferent.whatItIs.point2.description': '特に深夜、止めるのが最も難しい時間帯など、あなたの弱い時間。',
  'whyDifferent.whatItIs.point3.title': '立ち止まる方法を知っている',
  'whyDifferent.whatItIs.point3.description': 'プレッシャー、罪悪感、強制ブロックの代わりに、優しいリアルタイムサポート。',
  'whyDifferent.whatItIs.quote': '「Scrollmate は、あなたを制限するのではなく、理解することを中心に構築されています。」',

  // Gallery
  'gallery.image1.label': '画像 #5 – コンパニオンの感情',
  'gallery.image1.caption': 'それぞれがユニークな個性と感情スタイルを持つ AI キャラクターのキャスト。',
  'gallery.image2.label': '画像 #6 – インターフェースコンセプト',
  'gallery.image2.caption': 'より健康的な習慣を築くにつれて強くなる、関係性ベースの親密度システム。',
  'gallery.image3.label': '画像 #7 – 進捗概要',
  'gallery.image3.caption': 'デジタルウェルネスの成果を祝う、明確な週間勝利ダッシュボード。',

  // FAQ
  'faq.title': 'よくある質問',
  'faq.q1': 'Scrollmate は画面を記録しますか?',
  'faq.a1': 'いいえ。コンテンツではなく、パターンを検出します。',
  'faq.q2': 'どのプラットフォームをサポートしますか?',
  'faq.a2': 'ブラウザベースとモバイルファーストの体験をテストしています。',
  'faq.q3': 'いつローンチしますか?',
  'faq.a3': '早期アクセスメンバーが最初に知ることになります。',

  // Email Signup
  'signup.title': '早期アクセスプログラムに参加',
  'signup.subtitle': 'Scrollmate を試す最初のグループの一員になりましょう。早期アクセス、アップデート、限定機能を受け取れます。',
  'signup.emailPlaceholder': 'メールアドレスを入力',
  'signup.button': '早期アクセスを取得',
  'signup.submitting': '送信中...',
  'signup.success': '参加完了!すぐにご連絡します。',

  // Footer
  'footer.description': 'あなたの習慣を理解し、スマホ依存から抜け出すのを導く AI フレンド。',
  'footer.contact': 'お問い合わせ',
  'footer.privacy': 'プライバシーポリシー',
  'footer.terms': '利用規約',
  'footer.copyright': '© Scrollmate – Noffice Studio 制作。',
  'footer.poweredBy': 'Powered by Readdy',
};
